import { updateWaterClass } from "@services/waterClass";
import { useMutation } from "@tanstack/react-query";

export const useUpdateWaterClass = (options: any = {}) => {
  return useMutation(updateWaterClass, options);
};
